import utils from 'utils'
import fieldConfiguration from './fieldConfig'
import modalPage from './views/modalPage.html'
class registrationCodeManagementListCtrl {
    constructor($scope, httpRequest, $state, sweetalert, initSortService, $uibModal, logger, $location, composeService) {
        $scope.importconfig = {
            label: '导入更新',
            code: 'REGISTER_UPDATE_IMPORT',
            appName: host.etcloudOvat,
            url: 'dlTaskService/import_REGISTER_UPDATE_IMPORT',
            // downloadAppName: host.etcloudOvat,
            // downloadUrl: 'tax4/belleRegister/downloadRegisterUpdateTemplate',
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml',
                },
            },
            downloadRegisterUpdateTemplate() {
                let _url = `${host.etcloudOvat}tax4/belleRegister/downloadRegisterUpdateTemplate?accessToken=${localStorage.getItem('id_token')}`
                utils.file_download(
                    _url,
                    $scope.queryParam.param,
                    '', //type
                    'POST',
                    'blob',
                    '',
                    false
                )
            },
            callback() {
                queryList()
            },
        }
        $scope.selectedRows = []
        $scope.customizedConfig = fieldConfiguration
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        }
        const pathParam = $location.path().replace(/\//g, '-')
        $scope.orderMap = initSortService(pathParam)
        $scope.queryParam.orderMap = $scope.orderMap.wrap
        const initDict = () => {
            const dictTypeArr = ['auth_code_grant_state', 'department_no', 'yes_no_flag', 'apply_type', 'drawer_channel_type', 'register_type', 'belle_register_type']
            httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                $scope.dictData = res1.data.value
            })
        }
        const getAllTaxBureau = () => {
            // 获取所有主管税局信息
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.dictDataProvince = res.data.value
            })
        }
        $scope.reset = function () {
            $scope.queryParam.param = {}
        }
        //查询功能，和表头排序功能
        const queryList = () => {
            httpRequest.post_belleRegister($scope.queryParam).then((res) => {
                let result = res.data.value
                $scope.dataList = result.list
                $scope.totalItems = result.total
                $scope.queryParam.pageNum = result.pageNum
                $scope.selectedRows = []
            })
        }
        // 检查状态是否一致
        const isStateConsistent = (arr, prop) => {
            const referenceValue = arr[0][prop]
            return !arr.some((item) => item[prop] !== referenceValue)
        }
        $scope.init = composeService(queryList, getAllTaxBureau, initDict)
        $scope.init()
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = $scope.orderMap.wrap
            queryList()
        }
        $scope.search = function () {
            queryList()
        }
        $scope.pageChanged = function () {
            queryList()
        }
        $scope.tableDropdownConfig = [
            {
                label: '注册授权更新',
                handler(item) {
                    $scope.regAuthorizationUpdate([item])
                },
                showWhile(item, hasPermit) {
                    return hasPermit('reg_code_update')
                },
            },
        ]
        $scope.exportExel = function exportExel() {
            let _url = `${host.etcloudOvat}tax4/belleRegister/exportRegister?accessToken=${localStorage.getItem('id_token')}`
            utils.file_download(
                _url,
                $scope.queryParam.param,
                '', //type
                'POST',
                'blob',
                '',
                false
            )
        }
        $scope.regAuthorizationUpdate = (list) => {
            if (!list.length) return logger.logError('请选择数据')
            if (!isStateConsistent(list, 'authCodeGrantState')) return logger.logError('所选数据注册码授权状态不一致，请重新按条件筛选后选择')
            const modalInstance = $uibModal.open({
                template: modalPage,
                controller: 'modalPageCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-mg',
                resolve: {
                    items1() {
                        return list
                    },
                },
            })
            modalInstance.result.then((data) => {
                queryList()
            })
        }
    }
}
registrationCodeManagementListCtrl.$inject = ['$scope', 'httpRequest', '$state', 'sweetalert', 'initSortService', '$uibModal', 'logger', '$location', 'composeService']
export default registrationCodeManagementListCtrl



// WEBPACK FOOTER //
// ./src/app/system/permission/registrationCodeManagement/registrationCodeManagementListCtrl.js